import React from 'react';
import { ArrowRightIcon, ArrowTopRightOnSquareIcon } from '@heroicons/react/24/outline';
import SectionSurface from '../shared/SectionSurface';
import { APACHE_OSSIE_HUB } from '../../../content/enterpriseMessaging';

const OSSIE_CARDS = [
  {
    title: 'Define Once',
    body: 'Create governed business definitions, metrics, and relationships that can be reused across dashboards, applications, and AI agents.',
  },
  {
    title: 'Consume Everywhere',
    body: 'Prepare semantic models for use across Snowflake, Power BI, Tableau, QuickSight, Streamlit, Cortex, and future AI platforms.',
  },
  {
    title: 'Close the Context Gap',
    body: 'Give AI systems the business context they need to produce trusted, explainable, and consistent answers.',
  },
];

export default function OssieCTA() {
  const hub = APACHE_OSSIE_HUB;

  return (
    <SectionSurface variant="accent-enterprise" decor="nodes" bleed="both" flowTop flowBottom overlap>
      <div className="container-x min-w-0 py-8 sm:py-10">
        <div className="mx-auto max-w-5xl rounded-2xl bg-white p-7 shadow-md ring-1 ring-ink-200 sm:p-8">
          <p className="eyebrow">{hub.eyebrow}</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
            Building Toward an Open Semantic Future
          </h2>
          <p className="mt-4 text-sm leading-6 text-ink-600">{hub.body}</p>
          <p className="mt-4 text-sm leading-6 text-ink-600">
            As organizations adopt Snowflake Cortex, conversational BI, embedded analytics, and decision intelligence agents, the need for consistent metric definitions and reusable semantic context becomes critical. We help organizations prepare for this future by designing semantic foundations that are governed, portable, AI-ready, and aligned with Apache Ossie (Incubating).
          </p>

          <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
            {OSSIE_CARDS.map((card) => (
              <article key={card.title} className="card h-full min-w-0 p-5">
                <h3 className="text-base font-semibold text-ink-900">{card.title}</h3>
                <p className="mt-2 text-sm leading-6 text-ink-600">{card.body}</p>
              </article>
            ))}
          </div>

          <div className="mt-8 flex w-full min-w-0 flex-col items-stretch justify-center gap-3 sm:flex-row sm:flex-wrap sm:items-center">
            <a
              href={hub.primaryCta.href}
              target="_blank"
              rel="noreferrer"
              className="btn-primary btn-lg"
            >
              {hub.primaryCta.label}
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" />
            </a>
            <a href={hub.secondaryCta.href} className="btn-secondary btn-lg">
              {hub.secondaryCta.label}
            </a>
            <a
              href={hub.docsCta.href}
              target="_blank"
              rel="noreferrer"
              className="link-text"
            >
              {hub.docsCta.label}
              <ArrowTopRightOnSquareIcon className="h-3.5 w-3.5" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </SectionSurface>
  );
}
